import { render } from "./VMocha.vue?vue&type=template&id=2a44364a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VMocha.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a44364a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a44364a', __exports__)) {
    api.reload('2a44364a', __exports__)
  }
  
  module.hot.accept("./VMocha.vue?vue&type=template&id=2a44364a", () => {
    api.rerender('2a44364a', render)
  })

}


export default __exports__